import React, { useState } from 'react';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import './style.css';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';

import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import { FaCartPlus } from "react-icons/fa6";
import { MdOutlineZoomOutMap } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa6";
import { MdCurrencyRupee } from "react-icons/md";

import category1 from '../../../assets/categories/category1.png';
import { Link, useNavigate } from 'react-router-dom';
import whatsapp from '../../../WhatsApp/whatsapp';



const imageUrl = process.env.REACT_APP_BASH_IMG_URL


function Product({ item }) {
    const navigate = useNavigate();


    const { redirectToWhatsApp } = whatsapp()

    /* const handleClickeProduct = async () => {
        const product = {
            id: item?._id,
            name: item?.name,
            price: item?.price,
            image: `${imageUrl}/products/${item?.images[0]?.name}` // Example image URL
        };
        await redirectToWhatsApp(product)
    } */
    const handleCheckout = () => {
        navigate("/checkout", {
            state: {
                product: item,
                quantity: 1
            }
        });
    };

    return (
        <div className='productMainDiv'>
            {/* <Paper sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}> */}
            <div className='heartIconDiv'>
                <IconButton><CiHeart color='white' /></IconButton>
            </div>
            <div>
                <img src={item?.images[0]?.image} alt="category" className='imgProduct' />
            </div>


            <div className='hiddenIcons'>
                <Link to={`/Products/${item?._id}`} style={{ textDecoration: 'none' }}><IconButton><MdOutlineZoomOutMap color='white' /></IconButton></Link>
            </div>

            {/* <div className='hiddenContent' onClick={handleClickeProduct}>
                <IconButton><FaWhatsapp /></IconButton>
                <Typography variant='body' sx={{ textTransform: 'capitalize' }}>Click To By Now</Typography>
            </div> */}
            <div className='hiddenContent' onClick={handleCheckout}>
                <IconButton><ShoppingCartCheckoutIcon /></IconButton>

                <Typography variant="body2" sx={{ textTransform: "capitalize", fontWeight: 600 }}>Checkout</Typography>
            </div>

            <Box sx={{ mt: 3 }}>
                <Link to={`/Products/${item?._id}`}><Typography sx={{ textTransform: 'capitalize' }}>{item?.name}</Typography></Link>
                <Typography variant='body' sx={{ textTransform: 'capitalize', alignItems: 'center', display: 'flex' }}>price: <MdCurrencyRupee /> {item?.price}</Typography>
            </Box>
            {/* </Paper> */}
        </div >
    );
}

export default Product;
